<div id="dsw" style="min-height: auto; padding-bottom: 0">
    <div class="popup-overlay"></div>
    <div class="cst-popup popup-terms-n-conditions ">
      <div class="popup-header">
        <div class="flex-center space-between">
          <h2 translate>lblTerms&Conditions</h2>
          <em class="fas fa-times close-icn-popup popup-close" (click)="activeModal.close(false)"></em>
        </div>
      </div>
      <div class="popup-content">
        <div class="clearfix">
            <div class="panel-body myDiv">
                <div class="pdlr15 pdtb15">
                    <div class="termsContainer">
                        <span [innerHTML]="privacyConsent"></span>
                    </div>
                </div>
            </div>
          </div>
     </div>
  </div>
